/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { BlurredImageProps, BlurredImage } from "@components/elements";
import { css } from "@panda/css";

const styles = css({
	position: "absolute",
	pointerEvents: "none",
	top: 0,
	bottom: 0,
	right: 0,
	left: 0,
	width: "100%",
	smDown: {
		height: "100%",
	},
	"& .blurred-image, img, video": {
		smDown: {
			height: "100%",
		},
	},
});

export const HeroAlphaBlurredImage = (props: BlurredImageProps): React.JSX.Element => {
	return (
		<div className={styles}>
			<BlurredImage {...props} opacity={0.6} disableAutoplay />
		</div>
	);
};
